import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  LayoutDashboard,
  Globe,
  ClipboardList,
  Briefcase,
  TrendingUp,
  Banknote,
  Calculator,
  FileText,
  UserPlus,
  LogIn,
  Sparkles,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const pages = [
  { path: "/", label: "Page d'accueil (Auth)", icon: LogIn },
  { path: "/onboarding", label: "Onboarding", icon: UserPlus },
  { path: "/dashboard", label: "Dashboard principal", icon: LayoutDashboard },
  { path: "/my-website", label: "Mon Site Web", icon: Globe },
  { path: "/my-action-plan", label: "Mon Plan d'Action", icon: ClipboardList },
  { path: "/business-plan", label: "Business Plan", icon: Briefcase },
  { path: "/briefing", label: "Briefing", icon: Sparkles },
  { path: "/ventes", label: "Ventes", icon: TrendingUp },
  { path: "/tresorerie", label: "Trésorerie", icon: Banknote },
  { path: "/comptabilite", label: "Comptabilité", icon: Calculator },
  { path: "/social", label: "Réseaux Sociaux", icon: FileText },
  { path: "/financement", label: "Financement", icon: Briefcase },
  { path: "/parametres", label: "Paramètres", icon: Sparkles },
];

const AdminNav = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-2xl w-full space-y-6">
        <div className="text-center space-y-2">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-xs text-primary font-medium">
            <Sparkles className="h-3 w-3" />
            Admin Navigation
          </div>
          <h1 className="text-3xl font-bold text-foreground">Grafton IA — Toutes les pages</h1>
          <p className="text-sm text-muted-foreground">
            {user ? `Connecté : ${user.email}` : "Non connecté — certaines pages nécessitent une authentification"}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {pages.map((page) => (
            <Button
              key={page.path}
              variant="outline"
              className="h-auto py-4 px-5 justify-start gap-3 text-left hover:border-primary/40 hover:bg-primary/5 transition-all"
              onClick={() => navigate(page.path)}
            >
              <div className="h-9 w-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                <page.icon className="h-4 w-4 text-primary" />
              </div>
              <div>
                <p className="font-medium text-sm">{page.label}</p>
                <p className="text-xs text-muted-foreground">{page.path}</p>
              </div>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
